import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit {

  title: any;
  text: any;
  link?: any;

  constructor(
    private modal: NgbActiveModal
  ) {
  }

  ngOnInit(): void {
  }

  onClose() {
    this.modal.close({})
  }
}
